var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.705,
    height: 135,
    viewBox: "0 0 180.705 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#efeeec;}.b,.o{fill:#d81212;}.c{fill:#d1d1d1;}.d{fill:#6d8aa2;}.e{fill:#aa8080;}.f{fill:#8b5e5e;}.g{fill:#656d78;}.h{fill:#a2b5c4;}.i{fill:#ffd064;}.j{fill:#e8d1b3;}.j,.k,.l,.m,.n,.o,.p,.q,.r,.s{fill-rule:evenodd;}.k{fill:#16232c;}.l{fill:#adadad;}.m{fill:#dedede;}.n{fill:#9a9a9a;}.p{fill:#ffd9c9;}.q{fill:#6f6571;}.r{fill:#d9d9d9;}.s{fill:#cbc7cb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34 -161.371)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M93.68,111.386l27.778,27.766a5.414,5.414,0,0,0,3.828,1.585h39.479v73.886H20.813V140.737H60.292a5.414,5.414,0,0,0,3.828-1.585L91.9,111.386A1.261,1.261,0,0,1,93.68,111.386Z",
    transform: "translate(19.557 76.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.96,40.745a5.414,5.414,0,0,1,7.656,0l30.9,30.9h37.248L153.67,41.775l-3.925-10.566a6.37,6.37,0,0,0-5.971-4.152H41.8a6.37,6.37,0,0,0-5.971,4.152L20.813,71.644H58.061Z",
    transform: "translate(19.557 134.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M156.69,106.729a3.185,3.185,0,0,1-3.185,3.185H110.83A5.414,5.414,0,0,1,107,108.328L79.237,80.564a1.261,1.261,0,0,0-1.784,0L49.689,108.328a5.413,5.413,0,0,1-3.828,1.586H3.185A3.185,3.185,0,0,1,0,106.729v-4.459a3.185,3.185,0,0,1,3.185-3.185H43.618l30.9-30.9a5.414,5.414,0,0,1,7.656,0l30.9,30.9h40.433a3.185,3.185,0,0,1,3.185,3.185v4.459Z",
    transform: "translate(34 106.872)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M352.78,288.291v28.695h31.848V288.291a3.153,3.153,0,0,0-3.153-3.153H355.933A3.153,3.153,0,0,0,352.78,288.291Z",
    transform: "translate(-210.816 -47.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M352.78,389.2v1.632c0,.4,1.411.731,3.153.731h25.542c1.741,0,3.153-.327,3.153-.731V389.2Z",
    transform: "translate(-210.816 -119.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M87,288.291v28.695H55.154V288.291a3.153,3.153,0,0,1,3.153-3.153H83.849A3.153,3.153,0,0,1,87,288.291Z",
    transform: "translate(-4.275 -47.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M87,389.2v1.632c0,.4-1.411.731-3.153.731H58.307c-1.741,0-3.153-.327-3.153-.731V389.2Z",
    transform: "translate(-4.275 -119.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M233.393,288.286v47.168h-35.67v-19.61l1.62-2.364-1.62-2.364V288.287a3.153,3.153,0,0,1,3.153-3.153H230.24A3.153,3.153,0,0,1,233.393,288.286Z",
    transform: "translate(-103.213 -44.513)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 10.191,
    cy: 10.191,
    r: 10.191,
    transform: "translate(102.154 205.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M175.086,454.975H3.6c-1.986,0-3.6-.706-3.6-1.576v-2.261c0-.871,1.61-1.576,3.6-1.576H175.086c1.986,0,3.6.706,3.6,1.576V453.4C178.682,454.269,177.072,454.975,175.086,454.975Z",
    transform: "translate(36.023 -158.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M384.629,298.7h-13.56V285.138H366.34V298.7H352.781v4.729H366.34v13.559h4.729V303.426h13.56Z",
    transform: "translate(-210.818 -47.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M87,298.7H73.443V285.138H68.714V298.7H55.154v4.729h13.56v13.559h4.729V303.426H87Z",
    transform: "translate(-4.275 -47.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M197.723,370.03h5.733a2.364,2.364,0,0,1,0,4.729h-5.733Z",
    transform: "translate(-103.752 -103.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M400.195,228.265H382.021v6.313a2.841,2.841,0,0,0,2.834,2.836h6.537l3.9,1.97,4.9-1.97v-9.149Z",
    transform: "translate(-251.625 30.451)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M397.362,162.742H384.856a2.841,2.841,0,0,0-2.834,2.836v4.691H400.2v-4.691A2.841,2.841,0,0,0,397.362,162.742Z",
    transform: "translate(-251.625 86.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M400.2,206.463H382.022v4.458H400.2Z",
    transform: "translate(-251.625 49.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M236.18,293.7h-8.8v4.049a1.77,1.77,0,0,0,1.764,1.765H257.8c0-2.546,0-3.841-1.948-3.841l-3.879,0c-2.442,0-4.042-.629-4.936-1.97H236.18Z",
    transform: "translate(-87.609 -25.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M169.853,335.289h-25.2c-1.478,2.574-2.666,5.668-1.641,11.585,1.715-5.835,19.133-3.506,20.921,3.228h19.219c.727-1.647,1.413-3.273,2.013-4.916h-5.418C168.784,341.051,172.307,342.894,169.853,335.289Z",
    transform: "translate(-3.117 -61.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M249.5,130.31a41.144,41.144,0,0,1-1.458,5.586l-5.54,2.171-6.178-2.171c.216-11.691,4.585-17.3,8.3-19.112a9.02,9.02,0,0,1,2.711-1.4s1.8,2.887,1.9,2.887a15.508,15.508,0,0,1,.91,6.129Z",
    transform: "translate(-81.211 127.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.377,262.108h11.718c2.7.294,6.018,2.35,6.018,8.716V277.5l-2.659,1.584L220,277.5V272.34c0-2.546,0-3.841-1.948-3.841l-3.879,0c-2.442,0-4.042-.629-4.936-1.97A7.232,7.232,0,0,1,208.377,262.108Z",
    transform: "translate(-53.262 1.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M315.865,374.436a10.684,10.684,0,0,0-20.921-3.228,10.957,10.957,0,0,0-.469,2.885c-.012.392.257.343.625.343q10.381,0,20.766,0Z",
    transform: "translate(-155.055 -85.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M330,441.231H313.718a8.146,8.146,0,0,0,16.283,0Z",
    transform: "translate(-171.881 -152.739)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M30.676,428.81l-14.009,3.224a7.188,7.188,0,1,0,14.009-3.224Z",
    transform: "translate(168.793 -142.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M17.822,374.634a9.778,9.778,0,0,0-9.011-4.192c-6.337,1.34-8.4,5.128-8.811,9.852a9.765,9.765,0,0,0,.216,1.933c.041.18.159.106.355.061l2.193-.5,14.009-3.224,1.049-.241,1.466-.339A9.7,9.7,0,0,0,17.822,374.634Z",
    transform: "translate(182.695 -91.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M87.743,243.142,82.084,223.56l-2.548-1.14-2.85,1.14c3.744,10.379,2.7,17.624.171,24.538-.6,1.643-1.29,3.269-2.013,4.916h4.071Z",
    transform: "translate(103.775 35.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M206.325,64.848l-6.639-1.414c-.674.061-2.6,1.68-2.6,2.693l1.413,7.184a6.484,6.484,0,0,0,1.858.274,6.419,6.419,0,0,0,5.969-8.736Z",
    transform: "translate(-32.328 172.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M201.018,22.69a8.086,8.086,0,1,0-16.169,0,8.651,8.651,0,0,0,3.446,7.253,7.712,7.712,0,0,0,2.752,1.21V23.968c0-1.013.514-1.218,1.188-1.279h8.782Z",
    transform: "translate(-24.879 214.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M187.425,372.171h-6.116v3.853c0,.825.449.887,1.111.887H191.2C191.373,373.045,189.033,372.171,187.425,372.171Z",
    transform: "translate(-14.574 -93.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M103.629,184.817l-7.639,2.525c-.376.335.049,3.751.3,3.641h8.881v-5.623C105.172,184.253,104.6,184.5,103.629,184.817Z",
    transform: "translate(83.41 68.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M149.282,206.415h3.863c2.074,0,2.135-3.441-.3-3.641l-3.56-.286-.955,2.023Z",
    transform: "translate(26.559 52.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M193.08,167.916l-1.278-1.1c-3.2-2.758-7.247,1.9-2.968,4.675l3.6,2.337,1.813,1.177h5.737v-3.927l-3.564-.29Z",
    transform: "translate(-24.143 84.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M238.536,219.771Z",
    transform: "translate(-70.244 38.091)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus11);
export default __webpack_public_path__ + "static/media/status-11.21497ae1466650032d2c1fd8e8983499.svg";
export { ForwardRef as ReactComponent };